// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0px;
  padding: 0px;
  font-family: "Open Sans", sans-serif;
  width: 100%;
  height: 100%;
  /* background-color: #F2F3FC !important; */
}

.bg-theme {
  background: #358696 !important;
  box-shadow: 0px 5px 5px rgb(0 0 0 / 14%);
}

/* .headFont{ */
/* font-size: 26px; font-weight: 600; margin-left: 55px; color: #fff; */
/* } */
.nav-link {
  font-size: 0.85em !important;
  color: #000 !important;
}

.navbar-nav .nav-link.active,
.navbar-nav .show>.nav-link {
  /* color: var(--bs-navbar-active-color); */
  color: #FFFFFF !important;
  background-color: #83A4CF;
  border-radius: 20px;
  padding: 5px 10px;
  text-align: center;
}

.bus_nav_icon {
  font-size: 14px;
}

/********* Landing 2 Starts ********/
.dashboard_card {
  font-size: 1.1em;
  color: #000;
  font-weight: 600;
  text-align: center;
  cursor: pointer;
  transition: 0.5s;
  background: #fff;
  border: solid 1px #c3c3c3;
  box-shadow: 1px 1px 25px #33333320;
  padding: 45px 15px 45px 15px;
  margin-top: 20px;
  width: 100%;
}

.dashboard_card img {
  width: 50px;
}

.dashboard_card span {
  display: block;
  padding-top: 15px;
  font-weight: 600;
  line-height: 25px;
}

.dashboard_card:hover {
  box-shadow: 1px 1px 25px #999;
}

/********* Media Queries Starts ********/

@media (min-width: 836px) {
  .navbar-expand-sm {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
}

@media screen and (max-width: 991px) {}

@media screen and (max-width: 769px) {}

@media screen and (max-width: 420px) {}


.material-symbols-outlined {
  font-variation-settings:
    'FILL' 0,
    'wght' 400,
    'GRAD' 0,
    'opsz' 48
}
/* Added code */
.fixed-header .app-main_bus {
  padding-top: 0px;
  background-color: #F2F3FC !important;
}
.app-theme-white_bus.app-container {
  background: #F2F3FC !important;
}
.img-fluid_bus{max-width:100%;overflow-y: hidden;overflow-x: hidden;}`, "",{"version":3,"sources":["webpack://./src/componets/Dashboard_Bus/LayoutMain_Bus/Header_Bus.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,WAAW;EACX,YAAY;EACZ,0CAA0C;AAC5C;;AAEA;EACE,8BAA8B;EAC9B,wCAAwC;AAC1C;;AAEA,eAAe;AACf,uEAAuE;AACvE,MAAM;AACN;EACE,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;;EAEE,0CAA0C;EAC1C,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA,oCAAoC;AACpC;EACE,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,kCAAkC;EAClC,4BAA4B;EAC5B,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA,wCAAwC;;AAExC;EACE;IACE,iBAAiB;IACjB,2BAA2B;EAC7B;AACF;;AAEA,sCAAsC;;AAEtC,sCAAsC;;AAEtC,sCAAsC;;;AAGtC;EACE;;;;;AAKF;AACA,eAAe;AACf;EACE,gBAAgB;EAChB,oCAAoC;AACtC;AACA;EACE,8BAA8B;AAChC;AACA,eAAe,cAAc,CAAC,kBAAkB,CAAC,kBAAkB,CAAC","sourcesContent":["body {\r\n  margin: 0px;\r\n  padding: 0px;\r\n  font-family: \"Open Sans\", sans-serif;\r\n  width: 100%;\r\n  height: 100%;\r\n  /* background-color: #F2F3FC !important; */\r\n}\r\n\r\n.bg-theme {\r\n  background: #358696 !important;\r\n  box-shadow: 0px 5px 5px rgb(0 0 0 / 14%);\r\n}\r\n\r\n/* .headFont{ */\r\n/* font-size: 26px; font-weight: 600; margin-left: 55px; color: #fff; */\r\n/* } */\r\n.nav-link {\r\n  font-size: 0.85em !important;\r\n  color: #000 !important;\r\n}\r\n\r\n.navbar-nav .nav-link.active,\r\n.navbar-nav .show>.nav-link {\r\n  /* color: var(--bs-navbar-active-color); */\r\n  color: #FFFFFF !important;\r\n  background-color: #83A4CF;\r\n  border-radius: 20px;\r\n  padding: 5px 10px;\r\n  text-align: center;\r\n}\r\n\r\n.bus_nav_icon {\r\n  font-size: 14px;\r\n}\r\n\r\n/********* Landing 2 Starts ********/\r\n.dashboard_card {\r\n  font-size: 1.1em;\r\n  color: #000;\r\n  font-weight: 600;\r\n  text-align: center;\r\n  cursor: pointer;\r\n  transition: 0.5s;\r\n  background: #fff;\r\n  border: solid 1px #c3c3c3;\r\n  box-shadow: 1px 1px 25px #33333320;\r\n  padding: 45px 15px 45px 15px;\r\n  margin-top: 20px;\r\n  width: 100%;\r\n}\r\n\r\n.dashboard_card img {\r\n  width: 50px;\r\n}\r\n\r\n.dashboard_card span {\r\n  display: block;\r\n  padding-top: 15px;\r\n  font-weight: 600;\r\n  line-height: 25px;\r\n}\r\n\r\n.dashboard_card:hover {\r\n  box-shadow: 1px 1px 25px #999;\r\n}\r\n\r\n/********* Media Queries Starts ********/\r\n\r\n@media (min-width: 836px) {\r\n  .navbar-expand-sm {\r\n    flex-wrap: nowrap;\r\n    justify-content: flex-start;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 991px) {}\r\n\r\n@media screen and (max-width: 769px) {}\r\n\r\n@media screen and (max-width: 420px) {}\r\n\r\n\r\n.material-symbols-outlined {\r\n  font-variation-settings:\r\n    'FILL' 0,\r\n    'wght' 400,\r\n    'GRAD' 0,\r\n    'opsz' 48\r\n}\r\n/* Added code */\r\n.fixed-header .app-main_bus {\r\n  padding-top: 0px;\r\n  background-color: #F2F3FC !important;\r\n}\r\n.app-theme-white_bus.app-container {\r\n  background: #F2F3FC !important;\r\n}\r\n.img-fluid_bus{max-width:100%;overflow-y: hidden;overflow-x: hidden;}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
